import React, { Component } from 'react';

import { BaasicButtonTemplate } from 'themes/components';

class BaasicButton extends Component {
	render() {
		return <BaasicButtonTemplate {...this.props} />;
	}
}

BaasicButton.defaultProps = {
	type: 'button',
	onClick: () => {},
	className: 'btn btn--med',
	disabled: false,
	setRef: () => {},
	content: null,
	label: '',
	title: null,
	rotate: false,
	onlyIcon: false,
};

export default BaasicButton;
